// Collapsible sub-section inside a carrier card / account panel. The
// summary line carries the title AND a one-line digest of what's inside
// (e.g. "Fuel 5% · NI £1.00 · Remote £4.50"), so a collapsed card still
// tells the reader the state of every setting without opening it. Only
// sections that need attention (a missing secret, a failed test) open by
// default; everything else starts collapsed to keep the page short.

import type { ReactNode } from "react";

interface Props {
    title: string;
    /** Compact state digest shown to the right of the title. */
    summary?: ReactNode;
    /** Small pill after the title, e.g. "Needs setup" / "On". */
    badge?: { text: string; tone?: "ok" | "off" | "warn" } | null;
    defaultOpen?: boolean;
    children: ReactNode;
}

const CarrierSection = ({ title, summary, badge, defaultOpen = false, children }: Props) => (
    <details className="carrier-section" open={defaultOpen}>
        <summary className="carrier-section-summary">
            <span className="carrier-section-title">{title}</span>
            {badge && (
                <span className={`carrier-section-badge carrier-section-badge--${badge.tone ?? "off"}`}>{badge.text}</span>
            )}
            {summary && <span className="carrier-section-digest">{summary}</span>}
        </summary>
        <div className="carrier-section-body">{children}</div>
    </details>
);

export default CarrierSection;
